<template>
    <div :class="[
            'form__group',
            { 'form--error' : error },
            { 'form--hidden' : hidden }
        ]"
        :aria-hidden="hidden"
    >
        <label :for="id" :class="{ 'sr-only' : hideLabel }">{{ fieldLabel | capitalise }}</label>
        <input
            v-if="!textArea"
            v-bind="$attrs"
            v-on="listeners"
            :id="id"
            :name="id"
            ref="inputValue"
            :tabindex="tabIndex"
        />

        <textarea
            v-else
            v-bind="$attrs"
            v-on="listeners"
            :id="id"
            :name="id"
            ref="inputValue"
            rows="8"
        ></textarea>
        <slot></slot>
    </div>
</template>


<script>
import { capitalise } from '@/helpers'

export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            requited: false
        },
        id: {
            type: String,
            required: true
        },
        error: {
            type: Boolean,
            default: false
        },
        textArea: {
            type: Boolean,
            default: false
        },
        hideLabel: {
            type: Boolean,
            default: false
        },
        hidden: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        // This is how we pass back the events to the parent so we can use @click, v-model etc
        listeners () {
            return {
                ...this.$listeners,
                input: event => this.$emit('input', event.target.value),
            }
        },

        fieldLabel () { return this.label ? this.label : this.id },

        tabIndex () { return this.hidden ? -1 : 0 }
    },

    filters: {
        capitalise(str) {
            return str ? capitalise(str) : str
        }
    }
}
</script>
